import baseUrlLocal from '@/baseUrl.local';

interface ICheckParams {
  objectId: string;
  executetime: string;
  checktype: number;
}

let host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '';

if (process.env.NODE_ENV !== 'production') {
  host = baseUrlLocal;
}
export const baseURL = host + process.env.VUE_APP_API;

export default class Uri {
  baseURL: string = baseURL;
  /*Common*/
  designConfig = 'system/color';
  userInfo = 'current-user/detail-info';
  changePassword = 'current-user/update-password';
  changeRole = 'users/update-active-role';
  infoSystemInfo = 'info/systeminfo/';
  infoSystemInfoLogin = 'info/systeminfologin';
  i18nLkk = 'i18n';
  about = 'info/version/all';
  modulesAbout = 'info/version/all-modules';
  logout = 'logout';
  env = 'env';

  /*Login*/
  login = 'login';

  /*LKB*/
  usertakers = 'user/takers';
  applicationStatuscount = 'application/status-count-all';
  statuses = 'status';
  statusesFull = 'statuses/full';
  userSigner = 'user/signer';
  application = 'application/';
  appIdNew(id: string): string {
    return `${this.application}find/${id}`;
  }
  appId(id: string): string {
    return `${this.application}${id}/`;
  }
  appAbsUpdateStatus(id: string): string {
    return `${this.application}${id}/abs-update-status`;
  }
  clientDocs(id: string): string {
    return `${this.appId(id)}all-document`;
  }
  clientDocsDelete = `${this.application}delete-document`;
  downloadClientDocsExel(id: string): string {
    return `${this.appId(id)}docs-excel`;
  }
  /** Протокол проверки ЭП: без subType — по всем разделам заявки, с subType — по конкретному разделу */
  uploadingProtocol(id: string, subType = ''): string {
    return `${this.appId(id)}uploading-protocol` + (subType ? `?subType=${subType}` : '');
  }
  fieldDocs(id: string): string {
    return `${this.appId(id)}employee-document`;
  }
  fieldDocumentTypes(id: string): string {
    return `info/fielddocumenttypes/${id}`;
  }
  actualAddress(appId: string): string {
    return `${this.appId(appId)}actualaddress`;
  }
  regAddress(appId: string): string {
    return `${this.appId(appId)}regaddress`;
  }
  okpo(appId: string): string {
    return `${this.appId(appId)}okpo`;
  }
  ogrn(appId: string): string {
    return `${this.appId(appId)}ogrn`;
  }
  kpp(appId: string): string {
    return `${this.appId(appId)}kpp`;
  }
  okato(appId: string): string {
    return `${this.appId(appId)}okato`;
  }
  okved(appId: string): string {
    return `${this.appId(appId)}okved`;
  }
  commentApp(appId: string): string {
    return `${this.appId(appId)}comment`;
  }
  // listOkato:string = 'application/okato';
  // listOkved:string = 'application/okved';
  //todo переделать запрос. date сдеать параметром в теле запроса
  lifeDate(appId: string, date: string): string {
    return `${this.application}${appId}/lifedate/${date}`;
  }
  updateCheckResult({ objectId, executetime, checktype }: ICheckParams): string {
    return `check/${objectId}/${executetime}/${checktype}/result`;
  }
  updateCheckComment({ objectId, executetime, checktype }: ICheckParams): string {
    return `check/${objectId}/${executetime}/${checktype}/comment`;
  }
  recheck(id: string): string {
    return this.appId(id) + 'recheck/';
  }
  downloadReport(id: string, date: string, type: string): string {
    return `check/${id}/${date}/${type}/report`;
  }
  downloadZipped(uuids: string[], appId: string): string {
    return this.binary + '/' + uuids + '/' + appId + '/zipped/';
  }
  downloadBankForm(appId: string): string {
    return this.binary + '/' + appId + '/generatedbankdoc/';
  }
  downloadSheetApproval(appId: string): string {
    return this.binary + '/' + appId + '/generated-approval-sheet';
  }
  confirm = `${this.application}document-requirement/verify`;
  docRequirement = `${this.application}document-requirement/create`;
  docRecalled = `${this.application}document-requirement/recalled`;
  origProvided = `${this.application}doc/orig-provided`;

  downloadSignature(uuids: string[]): string {
    return this.application + uuids + '/download-signature';
  }
  deleteDoc(fileId: string): string {
    return `${this.application}document-file/${fileId}/delete`;
  }
  // deleteDoc(appId, docId):string{return `${this.appId(appId)}doc/${docId}`};
  docAddRequirement(appId: string): string {
    return `${this.appId(appId)}document-requirement/create`;
  }
  docAddRequirementV2(appId: string): string {
    return `${this.appId(appId)}document-requirement/create-by-subtype`;
  }
  docAddDell(fileId: string): string {
    return `${this.application}document-requirement/${fileId}/delete`;
  }
  docRecalledAll = `${this.application}document-requirement/delete`;
  checkOriginal(fileId: string): string {
    return `${this.application}document-file/${fileId}/check-original`;
  }
  downloadDigitalDocument(fileId: string): string {
    return `digital-document-download/${fileId}`;
  }
  downloadFile(docId: string): string {
    return this.binary + '/' + docId;
  }
  uploadDocument(appId: string): string {
    return `${this.appId(appId)}add-document`;
  }
  questionnaire(id: string): string {
    return `${this.appId(id)}questionnaire-new/`;
  }
  questionnaireStepOne(id: string): string {
    return `${this.appId(id)}questionnaire-first-step`;
  }
  searchAddr = 'suggest/address';
  searchOrg = 'searchDadataOrg';
  searchCountry = 'suggest/country';

  updateCheckOldResultExecutetime(objectId: string): string {
    return `check/smaw-old/${objectId}`;
  }
  updateSmawCurrentCheckResultExecutetime(objectId: string): string {
    return `check/smaw/${objectId}`;
  }

  pendingList = 'pending-list';
  updatePending = 'pending-update';
  deletePending(id: string): string {
    return `pending/${id}`;
  }
  uploadPhoto = 'users/photos';
  downloadPhoto(fileId: string): string {
    return `users/photos/${fileId}`;
  }

  /*Applications*/

  pdnFields = 'admin/pdn-fields';
  downloadJournalDeletePdn = `${this.pdnFields}/download`;
  updatePdnFields(id: string): string {
    return `${this.pdnFields}/${id}`;
  }
  applications = 'application/all';
  applicationsTimeDownload = 'application/all/download';
  appSaveFilter = 'application/filter/'; //todo перенести в store/user
  blocks = 'application/all-block';
  applicationPostActInDiadoc = 'application/post-act-in-diadoc';
  applicationCreateActInDiadoc = 'application/create-act-in-diadoc';
  applicationPersonalData = 'application/personal-data';
  sendActToEdo(agentId: string) {
    return `sbis/send-new-documents/${agentId}`;
  }
  sendDocumentsToEdo(appId: string) {
    return `sbis/send-exist-documents/${appId}`;
  }

  actionsWork(id: string) {
    return `${this.appId(id)}work`;
  }
  appAction({ appId, actionId }: { appId: string; actionId: string }): string {
    return `${this.appId(appId)}step/${actionId}`;
  }
  generateBankForm(appId: string): string {
    return `${this.appId(appId)}generatebankform`;
  }
  generateLinkLkk(appId: string): string {
    return 'application/auth-client/' + appId;
  }
  getLinkLkkApp(appId: string): string {
    return 'link-login-to-lkk/' + appId;
  }
  updateAppForAbs(appId: string): string {
    return 'updateAppForAbs/' + appId;
  }
  updateDataApp(appId: string): string {
    return 'application/synchronization/' + appId;
  }
  filterModels = 'filter-models';
  filterModelsCreate = 'filter-models/create';
  deleteFilterModels(id: number | string): string {
    return `filter-models/delete/${id}`;
  }
  storageSettings = 'storage-settings';
  applicationSignBinary(uuids: string): string {
    return 'application/' + uuids + '/sign';
  }

  applicationDocumentsForms(uuids: string): string {
    return 'application/' + uuids + '/documents-forms';
  }
  applicationDocumentsFormSpostDocumentInDiadoc(uuids: string): string {
    return 'application/' + uuids + '/post-document-in-diadoc';
  }

  /*ClientList*/
  clientReport = 'client/report/';
  reportCount = 'client/report/count';
  deleteClient(id: string): string {
    return `client/${id}`;
  }
  clientAdditionalNumberActive(clientId: string, numberId: string): string {
    return `client/${clientId}/additional-number/${numberId}/active`;
  }
  clientApplications(id: string): string {
    return `client/application?clientId=${id}`;
  }
  deleteClientApp(id: string): string {
    return `client/application?appId=${id}`;
  }

  /*bank questionnairies*/
  bankForm = 'bankform';
  typeDocsBySubtype(subtype: string): string {
    return `documenttypes/subtype/${subtype}`;
  }
  typeDocsLkbFormBank = this.typeDocsBySubtype('LKB_FORM_BANK');

  valuesForm = 'valuesform';
  testbankform = 'testbankform';
  form = 'form';
  migration = 'form/migration';
  form2 = 'bankform';
  downloadForm(id: string): string {
    return `${this.form}/${id}`;
  }
  downloadForm2(id: string): string {
    return `${this.form2}/${id}`;
  }
  formLkr = 'form?system=LKR';
  formLkk = 'form?system=LKK';

  /*StatusModel*/
  statebranch = 'statebranch';
  statebranchId(id: string): string {
    return `${this.statebranch}/${id}`;
  }
  branchtype = 'branchtype';
  lkbrole = 'lkbrole';
  status = 'status';
  transitionsConditions = 'status/automatic-settings/all';
  updateTransitionsConditions = 'status/automatic-settings/update';

  /*DocumentsTypes*/
  documenttype = 'documenttype';
  documenttypeId(id: string, type: string): string {
    return `${this.documenttype}/${id}/${type}`;
  }
  unBlockedDocs(id: string, type: string): string {
    return `${this.documenttype}/${id}/${type}/extract-archive`;
  }
  order = 'documenttype/order';
  documenttypeInfo = 'documenttype/info';
  blockedDocs = 'documenttype/all-delete';
  getDocumentTypesBySubtype = 'get-document-type-by-sub-type';
  addParticipant(appId: string, fileId: string) {
    return `generate-docs/${appId}/downloaded/add-participant/${fileId}`;
  }
  signedDocTypes(appId: string): string {
    return `generate-docs/${appId}/signed-doc-type`;
  }
  participantSignatories(appId: string): string {
    return `generate-docs/${appId}/signed-participant`;
  }
  dynamicDictionary(appId: string): string {
    return `generate-docs/${appId}/value-dictionary`;
  }
  generateDocs(appId: string): string {
    return `generate-docs/${appId}/form `;
  }
  electronicGenerate(appId: string): string {
    return `electronic-document/${appId}/generate `;
  }

  electronicGenerateForLKK = 'electronic-document/document-for-kk';

  electronicGenerateFromTemplate = 'electronic-document/generate';

  metadataResultByTemplateId(appId: string, templateId: string): string {
    return `electronic-document/${appId}/${templateId}/metadata`;
  }
  electronicGenerateMetaData(appId: string): string {
    return `electronic-document/${appId}/generate-metadata`;
  }
  electronicGenerateMetaData2 = 'electronic-document/generate-metadata';
  electronicSaveMetaData(appId: string, fileId: string): string {
    return `electronic-document/${appId}/save-metadata/${fileId}`;
  }
  electronicSaveMetaDataByFileid(appId: string, fileId: string): string {
    return `electronic-document/${appId}/metadata/${fileId}`;
  }
  bankSignatoriesByOfficeId(officeId: number): string {
    return `users/signed-bank/${officeId}`;
  }
  temporaryDocuments(appId: string): string {
    return `${this.appId(appId)}temporary-document`;
  }

  deleteTemporaryDocument(appId: string, fileId: string): string {
    return `${this.appId(appId)}temporary-document/${fileId}`;
  }

  downloadTemporaryDocument(appId: string, fileId: string): string {
    return `${this.appId(appId)}temporary-document/${fileId}/upload`;
  }

  /*Internationalization*/
  binary = 'binary';
  binaryLegEntity: string = this.binary + '/legal-entity';
  binaryIndividual: string = this.binary + '/individual';
  binaryPhysicalEntity: string = this.binary + '/physical-entity';

  binaryManager: string = this.binary + '/employee';
  localeList = 'i18n/language';
  /*get - получить список, post - изменить*/
  localeSelect(id: string): string {
    return `i18n/${id}`;
  }

  /*Users/users*/
  users = 'users/all';
  roles = 'role/all';
  client = 'client';
  rolesSigners = 'role/signers'; // Роли которые Подписанты
  addUser = 'users/add';
  validUserDomain(domainName: string): string {
    return `users/validate/${domainName}`;
  }
  updateUser = 'users/update';
  blockedUsers = 'users/all/archive';
  blockedUser(id: string): string {
    return `users/to-archive/${id}`;
  }
  unBlockedUser(id: string): string {
    return `users/extract-archive/${id}`;
  }

  /*Users/roles*/
  menu = 'client-menu/all';
  menuTree = 'client-menu/all-tree';
  clientMenuLeaves(roleId?: number | null): string {
    if (roleId) {
      return `client-menu/leaves?roleId=${roleId}`;
    }
    return 'client-menu/leaves';
  }
  privileges = 'privilege/all';
  addRole = 'role/add';
  updateRole = 'role/update';
  sortRole = 'role/update/order';
  blockedRoles = 'role/all/archive';
  blockedRole(id: string): string {
    return `role/to-archive/${id}`;
  }
  unBlockedRole(id: string): string {
    return `role/extract-archive/${id}`;
  }

  /*Administration*/
  mainsysset = 'admin/sysflag';
  sysParameters = 'admin/sysparameter';
  dropBD = 'admin/truncatedb';
  exportInfo = 'database/info';
  downloadFileExportInfo = 'database/export';
  uploadSetting = 'database/import';
  desingEnvLkb = 'design/env/LKB';
  desingEnvLkk = 'design/env/LKK';
  desingEnv = 'design/env/';
  uploadEnvImage = 'design/env/image';
  updateSystem = 'questionnaire/update-all-counterparties';
  isUpdateSystem = 'env/updated-form ';

  referralLinksAll = 'referral-links/all';
  referralLinksSave = 'referral-links/save';
  deleteReferralLinks(schemaId: string): string {
    return `referral-links/${schemaId}`;
  }

  fileDownload(srcImg: string): string {
    return `file-download/${srcImg}`;
  }
  downloadFiledocument(docId: string) {
    return 'file-download/' + docId;
  }
  downloadDocument(fileId: string): string {
    return `file-download/${fileId}`;
  }

  binaryLoadImg(srcImg: string): string {
    return `${this.binary}/${srcImg}`;
  }
  clientFile(srcImg: string): string {
    return `${this.binary}/client/${srcImg}`;
  }
  binaryLoadImgDesing(srcImg: string): string {
    return `${this.baseURL}${this.binary}/${srcImg}`;
  }
  marketing = 'admin/administration/marketing';
  marketings = this.marketing + 's';
  applicationJournal = 'admin/application-journal';
  applicationJournalId(id: string): string {
    return `${this.applicationJournal}/${id}`;
  }
  applicationJournalBatch = 'admin/application-journal/batch';

  /*ApplicationStatuses*/
  canrequestdocs(id: string): string {
    return `${this.status}/${id}/canrequestdocs`;
  }
  showfinalresult(id: string): string {
    return `${this.status}/${id}/showfinalresult`;
  }
  statusId(id: string): string {
    return `${this.status}/${id}`;
  }

  /*Checks*/
  check = 'check';
  checkOrder = 'check/order';
  checkId(id: string): string {
    return `${this.check}/${id}`;
  }
  checkinfo = 'checkinfo';
  checkGroup = 'check/group';
  checkGroupId(id: string): string {
    return `${this.checkGroup}/${id}`;
  }
  checkGroupOrder = 'check/group/order';
  checkOkved = 'check/okved';
  checkInn = 'check/inn';
  uploadStatementDocument(appId: string): string {
    return `check/egrul-download/${appId}`;
  }
  manualCheckFile = 'check/manual/file';

  /*Setting: IntegrationAbs*/
  internalserviceGetparameters = 'internalservice/getparameters';
  statusIntegrationAbs = 'status';
  internalserviceSaveparameters = 'internalservice/saveparameters';

  /*smartan generate cheker */

  smartanDocTypeExist = 'smartan-request/isActive';

  egrulForm = 'egrul-form';
  settingsApiXml = 'settings-api-xml';

  /*Jobs*/
  jobs = 'jobs';
  job = 'job';
  changeJob(id: number): string {
    return this.job + '/' + id;
  }

  /*Setting: Reserve-currency-accounts */
  reserveCurrencyAccountSetting = 'currency/setting-accounts';
  createReserveCurrencyNumber = 'currency/create-account';
  editReserveCurrencyNumber = 'currency/edit-account';
  reserveCurrencyList(appId: string) {
    return `/currency/list-accounts/${appId}`;
  }
  deleteReserveCurrencyNumber = 'currency/delete-account';
  notifyCurrencyAccount = 'currency/notify-account';

  /*Setting: Currency-account */
  currencyAccountSetting = 'currency/id-currency-account';
  currencyTransitAccounts(appId: string) {
    return `/currency/list-foreign-exchange-accounts/${appId}`;
  }
  createTransitCurrencyAccountAuto(appId: string) {
    return `/currency/create-foreign-exchange-account-auto/${appId}`;
  }
  createAndUpdateTransitCurrencyAccount = 'currency/create-update-foreign-exchange-account';
  deleteTransitCurrencyAccount = 'currency/delete-foreign-exchange-account';
  // editReserveCurrencyNumber:string = 'currency/edit-account';
  // reserveCurrencyList(appId: string) { return `/currency/list-accounts/${appId}`;};
  // deleteReserveCurrencyNumber:string ='currency/delete-account';
  // notifyCurrencyAccount:string = 'currency/notify-account';

  /*Setting: ModalReserveAccount */
  reservationAccount(appId: string) {
    return `reservation/account/${appId}`;
  }

  /*Setting: BanksAndOffices*/
  office = 'office';
  bankOffices = 'bankoffices';
  bankOfficesOrder = 'office/update/order';
  regionOfficesOrder = 'region/update/order';
  region = 'region';
  regionId(id: string): string {
    return `${this.region}/${id}`;
  }
  showRegionId(id: string): string {
    return `${this.region}/extract-archive/${id}`;
  }
  bank = 'bank';
  bankId(id: string): string {
    return `${this.bank}/${id}`;
  }
  saveOffice(bankid: string, regionid: string): string {
    return `${this.office}/${bankid}/${regionid}`;
  }
  officeId(id: string): string {
    return `${this.office}/${id}`;
  }
  showOfficeId(id: string): string {
    return `${this.office}/extract-archive/${id}`;
  }

  /*Notification*/
  mailTemplate = 'mailtemplate';
  mailTemplateId(id: string): string {
    return `${this.mailTemplate}/${id}`;
  }
  smsTemplate = 'smstemplate';
  smsTemplateId(id: string): string {
    return `${this.smsTemplate}/${id}`;
  }
  event = 'event';
  notified = 'notified';
  notifiedInfo = 'notified/info';
  notifiedId(id: string): string {
    return `${this.notified}/${id}`;
  }

  /*report*/
  billing = 'report/billing';
  dadata = 'report/dadata';
  resourceBilling = '/report/billing/check';
  resourceDadata = '/report/dadata/check';
  downlBilling = 'report/billing/download';
  downlDadata = 'report/dadata/download';
  processingTime = 'report/processing-time';
  processingTimeTemplate = 'report/processing-time/templates';
  processingTemplateId(fileId: string): string {
    return `standardized-files/${fileId}`;
  }
  processingTimeDownload = 'report/processing-time/download';
  applicationTimeDownload = 'report/application-report/download ';

  processingTimeOfficeWorkTime = 'report/processing-time/filter/office-work-time';
  processingTimeHolidays = 'report/processing-time/filter/holidays';
  processingTimeSave = 'report/processing-time/filter/save';

  getProcessingTimeFilters = 'report/processing-time/filters';
  createProcessingTimeFilters = 'report/processing-time/filters/create';
  deleteProcessingTimeFilters(schemaId: string): string {
    return `report/processing-time/filters/${schemaId}`;
  }
  billingSettings = 'report/billing/settings';

  /* app sections */

  stateRequestDigitalProfile(snils: string) {
    return `digital-profile/fl/${snils}`;
  }
  createRequestDigitalProfile = 'digital-profile/fl';
  downloadDigitalProfile(snils: string, applicationId?: string) {
    const queryId = applicationId ? `?applicationId=${applicationId}` : '';
    return `digital-profile/fl/create-act/${snils}` + queryId;
  }

  createRequestNbki = 'nbki';
  stateAllRequestNbki(applicationId: string) {
    return `nbki/all/${applicationId}`;
  }
  viewReportNbki(reportId: string) {
    return `nbki/generate/${reportId}`;
  }
  downloadReportNbki(reportId: string) {
    return `nbki/generate/full/${reportId}`;
  }

  // Диасофт (ROS-1344): uuid заявки передаётся в теле запроса, не в пути
  sdmDsoftClientAndBkiMessage = 'sdm-dsoft/client-and-bki-message';
  sdmDsoftCreditDecision = 'sdm-dsoft/credit-decision';

  secionList = 'sections/all';
  sectionSave = 'sections/save';
  sectionUpdateName = 'sections/update-name';
  sectionUpdateActive = 'sections/update-active';
  sectionSorted = 'sections/all-sorted';
  sectionDelete(id: string): string {
    return `sections/${id}`;
  }

  agentSave = 'agent';
  agentSaveUp(id: string): string {
    return `agent/${id}`;
  }
  agentAll = 'agent/all';
  agentToArchive(id: string): string {
    return `agent/to-archive/${id}`;
  }
  agentExtractArchive(id: string): string {
    return `agent/extract-archive/${id}`;
  }

  userAgentSave = 'user-agent';
  userAgentSaveUp(id: string): string {
    return `user-agent/${id}`;
  }
  userAgentAll = 'user-agent/all';
  userAgentToArchive(id: string): string {
    return `user-agent/to-archive/${id}`;
  }
  userAgentExtractArchive(id: string): string {
    return `user-agent/extract-archive/${id}`;
  }
  applicationAppIdReportDate(id: string): string {
    return `application/${id}/report-date`;
  }

  applicationAppIdAgent(id: string): string {
    return `application/${id}/agent`;
  }
  agentListAr = 'agent';
  userAgentAllAgentId(id: string): string {
    return `user-agent/all/${id}`;
  }
  bankMaterialsAll = 'bank-materials/all';
  postBankMaterials = 'bank-materials';
  bankMaterialsId(id: string): string {
    return `bank-materials/${id}`;
  }
  bankMaterialsToActive(id: string): string {
    return `bank-materials/to-active/${id}`;
  }
  bankMaterialsFromActive(id: string): string {
    return `bank-materials/from-active/${id}`;
  }

  appReport = 'report/application-report';
  getAppReportTable: string = this.appReport + '/table';
  getAppReportCount: string = this.appReport + '/count';
  getAppReportFilters: string = this.appReport + '/filters';
  createAppReportFilters: string = this.appReport + '/filters/create';
  deleteAppReportFilters(schemaId: number): string {
    return `${this.appReport}/filters/${schemaId}`;
  }

  usersPhone = 'user-phone';
  deleteUsersPhone(schemaId: string): string {
    return `user-phone/${schemaId}`;
  }

  usersGroupAll = 'users-group/all';
  usersGroup = 'users-group';
  deleteUsersGroup(schemaId: string): string {
    return `users-group/${schemaId}`;
  }
  notificationTypes(docId?: number, docLe?: string): string {
    if (!docId && !docLe) {
      return `${this.application}sending-type`;
    }
    return `${this.application}sending-type/${docId}/${docLe}`;
  }
  notificationSendingDocs(appId: string, target: string): string {
    return `${this.application}${appId}/sending-docs/${target}`;
  }
  changeDocumentType(appId: string): string {
    return `${this.application}${appId}/document-type/change`;
  }
  sendingMultipleDocs(appId: string): string {
    return `${this.application}${appId}/sending-group-docs/counterparty`;
  }

  /*analytics*/
  initTableAnalytic = '/analytics/report';
  getAnalyticSchema = '/analytics-schema';
  updateAnalyticSchema = '/analytics-schema-update';
  deleteAnalyticSchema(schemaId: string): string {
    return `/analytics-schema-delete/${schemaId}`;
  }

  /*updateColorSchemaDesign*/
  updateColorSchemaDesign(id: string): string {
    return `/current-user/update-color-schema-design/${id}`;
  }
  phoneContactAll = '/phone-contact/all';
  phoneContact = '/phone-contact';
  phoneContactId(id: string): string {
    return `${this.phoneContact}/${id}`;
  }
  mangoSettings = '/mango-settings';
  rafpSettings = '/rafp-settings';
  radarSettings = '/radar-params';
  radarQuestionFields = 'radar-question-fields';
  radarQuestionFieldsId(id: number): string {
    return `radar-question-fields/${id}`;
  }
  radarReferralLink(appId: string): string {
    return `radar/referral-link/${appId}`;
  }

  logo_img: string = this.baseURL + 'logo/login';
  logo_header: string = this.baseURL + 'logo/system';
  bg_img: string = this.baseURL + 'system/image/BG_MAIN_IMAGE';
  bg_content_img: string = this.baseURL + 'system/image/BG_CONTENT_IMAGE';

  /*LKU settings lkk-user-api*/

  lkkUserApi = 'lkk-user-api';
  lkkUserApiAll = `${this.lkkUserApi}/all`;
  lkkUserApiFileById(id: string): string {
    return `${this.lkkUserApi}/${id}/file`;
  }
  lkkUserApiBlockedById(id: string): string {
    return `${this.lkkUserApi}/${id}/blocked`;
  }
  listInn = '/check/inn/download';

  renameFileName(fileId: string, newName: string) {
    return `file/${fileId}?newName=${newName}`;
  }

  allStatuses = 'statuses/full';

  certificate = 'certificate';
  certificateDate = 'certificate/date';

  /* collabora */

  collaboraGetToken(fileId: string, editable = false): string {
    return `wopi/token/${fileId}?editable=${editable}`;
  }

  /* correspondent banks */
  correspondentBankAll = 'correspondent-bank/all';
  correspondentBankSave = 'correspondent-bank';
  correspondentBankSaveUp(id: string): string {
    return `correspondent-bank/${id}`;
  }
  correspondentBankToArchive(id: string): string {
    return `correspondent-bank/to-archive/${id}`;
  }
  correspondentBankExtractArchive(id: string): string {
    return `correspondent-bank/extract-archive/${id}`;
  }

  /* correspondent bank users */
  correspondentBankUserAll = 'user-correspondent-bank/all';
  correspondentBankUserList = 'user-correspondent-bank';
  correspondentBankUserSaveUp(id: string): string {
    return `user-correspondent-bank/${id}`;
  }
  correspondentBankUserToArchive(id: string): string {
    return `user-correspondent-bank/to-archive/${id}`;
  }
  correspondentBankUserExtractArchive(id: string): string {
    return `user-correspondent-bank/extract-archive/${id}`;
  }

  createApp = 'application/create-app-lkb/login';
}

export const uri = new Uri();
